module.exports = __webpack_public_path__ + "static/media/foto_2.0d839722.png";